import * as lodash from 'lodash';
import { PLATFORM_TYPES } from '@sitegen/common/constants/platforms';

export const SITEGEN_CTA_VALUE: string = 'SiteGen';
export const PLAYER_PROFILE_URL: string = '/api/v1/{code}/phases/{phaseId}/players/{userId}';
export const PLAYER_BETA_GROUP_URL: string = '/api/v1/{code}/phases/{phaseId}/players/{userId}/playerGroups/{playerGroupId}';
export const PLATFORM_PLAYER_GROUPS_URL: string = '/api/v1/{code}/phases/{phaseId}/playergroups';
export const PLAYER_INVITE_FRIEND_URL: string = 'api/v1/{code}/phases/{phaseId}/players/{userId}/friends';
export const PLAYER_FRIENDS_STATUS_URL: string = 'api/v1/{code}/phases/{phaseId}/friends';
export const PLAYER_BETA_KEYS_URL: string = 'api/v1/{code}/phases/{phaseId}/players/{userId}/keys';
export const CUSTOM_FIELDS_URL: string = 'api/v1/{code}/phases/{phaseId}';

export enum BETA_API_ERROR {
    INVALID_REQUEST = 'INVALID_REQUEST',
    INVALID_INTEGRATION_TYPE = 'INVALID_INTEGRATION_TYPE',
    INVALID_AUTH_INFO = 'INVALID_AUTH_INFO',
    INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
    INVALID_PLAYER_GROUP_PLAYER = 'INVALID_PLAYER_GROUP_PLAYER',
    UNEXPECTED_ERROR = 'UNEXPECTED_ERROR'
}

export enum NDA_STATUS {
    SIGNED = 'SIGNED',
    NOT_SIGNED = 'NOT_SIGNED',
    NOT_SPECIFIED = 'NOT_SPECIFIED'
}

export const PLATFORM_TO_BETA_PLATFORM_ID: { readonly [key: string]: number } = {
    [PLATFORM_TYPES.PC]: 1,
    [PLATFORM_TYPES.PS3]: 2,
    [PLATFORM_TYPES.PS4]: 3,
    [PLATFORM_TYPES.XONE]: 4,
    [PLATFORM_TYPES.X360]: 5,
    [PLATFORM_TYPES.WIIU]: 6,
    [PLATFORM_TYPES.WEB]: 7,
    [PLATFORM_TYPES.MOBILE]: 8,
    [PLATFORM_TYPES.IOS]: 9,
    [PLATFORM_TYPES.ANDROID]: 10,
    [PLATFORM_TYPES.OCULUSVR]: 11,
    [PLATFORM_TYPES.STEAMVR]: 12,
    [PLATFORM_TYPES.SWITCH]: 13,
    [PLATFORM_TYPES.STADIA]: 15,
    [PLATFORM_TYPES.EPIC]: 16,
    [PLATFORM_TYPES.PS5]: 17,
    [PLATFORM_TYPES.XSX]: 18,
    [PLATFORM_TYPES.LUNA]: 19
};

export const BETA_PLATFORM_ID_TO_PLATFORM: { readonly [key: string]: PLATFORM_TYPES }
    = lodash.invert(PLATFORM_TO_BETA_PLATFORM_ID) as { readonly [key: string]: PLATFORM_TYPES };

export const REGION_MATCH_ONLY_PLATFORMS = [
    PLATFORM_TYPES.PS4,
    PLATFORM_TYPES.PS5,
    PLATFORM_TYPES.XONE,
    PLATFORM_TYPES.XSX
];
